/**
 * 发送给客户端的消息事件
 */
export enum ClientMessageEvent {
  WS_SUBSCRIBED = "ws-subscribed",
  WS_NOTIFICATION = "ws-notification",
}

/**
 * 发送给Service Worker的消息事件
 */
export enum SWMessageEvent {
  login = "login",
  logout = "logout",
}
